var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.5px",
    height: "16.5px",
    viewBox: "0 0 13.5 16.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "insurance_transavia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShoppingCart",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "insurance_transavia",
    transform: "translate(-5.250000, -3.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12,3.75 C12,3.75 9.0545,5.34675 5.25,5.34675 C5.25,5.34675 5.25,7.73775 5.25,12.3105 C5.25,18.274 12,20.25 12,20.25 C12,20.25 18.75,18.274 18.75,12.3105 C18.75,7.738 18.75,5.34675 18.75,5.34675 C14.9455,5.34675 12,3.75 12,3.75 Z M16.25,13 L12.75825,12.15025 C12.75025,12.81775 12.60675,13.74075 12.5305,14.36675 L13.75,15.35275 L13.75,15.75 L11.9975,15.20975 L10.25,15.75 L10.25,15.35275 L11.4645,14.367 C11.38825,13.74075 11.266,12.818 11.258,12.1505 L7.75,13 L7.75,12.31525 L11.25,10.20975 C11.25,9.33175 11.25,8.50925 11.25,8.50925 C11.25,7.6975 11.62,7.00525 11.9975,7.00525 C12.375,7.00525 12.75,7.68875 12.75,8.50925 C12.75,8.50925 12.75,9.33175 12.75,10.20975 L16.25,12.31525 L16.25,13 Z",
    id: "Shape",
    fill: "#2800A0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsurance);
export default __webpack_public_path__ + "static/media/icon-insurance.1f8cb94505f9680b0eda3eff4328b853.svg";
export { ForwardRef as ReactComponent };